/**
 * marketplace-filter-constants — client/server-shared constants for the W45
 * multi-marketplace UI dimension.
 *
 * Lives outside marketplace-filter.ts because that file imports `next/headers`
 * which is server-only. Client components (CountrySelector, RetailerTabs)
 * import from this file instead so the bundler does not try to ship
 * `next/headers` to the browser.
 */

export const VALID_RETAILERS = [
  "trendyol_tr",
  "emag_ro",
  "emag_hu",
  "emag_bg",
  "allegro_pl",
] as const;

export type RetailerCode = (typeof VALID_RETAILERS)[number];

export const MARKETPLACE_COOKIE = "commerco_active_marketplace";

export interface RetailerOption {
  code: RetailerCode | null;
  label: string;
  flag: string;
  aria: string;
}

export const RETAILER_OPTIONS: RetailerOption[] = [
  { code: null, label: "Tümü", flag: "🌍", aria: "Tüm pazaryerleri" },
  { code: "trendyol_tr", label: "Trendyol", flag: "🇹🇷", aria: "Trendyol Türkiye" },
  { code: "emag_ro", label: "eMAG RO", flag: "🇷🇴", aria: "eMAG Romania" },
  { code: "emag_hu", label: "eMAG HU", flag: "🇭🇺", aria: "eMAG Hungary" },
  { code: "emag_bg", label: "eMAG BG", flag: "🇧🇬", aria: "eMAG Bulgaria" },
  { code: "allegro_pl", label: "Allegro", flag: "🇵🇱", aria: "Allegro Poland" },
];
